import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import Error from "./Error";

const ErrorPage: React.FC = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <Error />;
  }

  const errorMessage = error instanceof Error ? error.message : "An unexpected error occurred.";

  return (
    <div className="p-4 text-center text-red-600">
      <h1 className="text-xl font-bold">Oops! Something went wrong.</h1>
      <p>{errorMessage}</p>
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-2 mt-4 text-white bg-orange-500 rounded hover:bg-orange-600"
      >
        Refresh Page
      </button>
    </div>
  );
};

export default ErrorPage;